import {
  FETCH_CONTENT_CARDS_REQUEST, FETCHING_CONTENT_CARDS_SUCCEEDED, FETCHING_CONTENT_CARDS_FAILED,
  INVALIDATE_CONTENT_CARDS,

  FETCH_CONTENT_CARD_REQUEST, FETCHING_CONTENT_CARD_SUCCEEDED, FETCHING_CONTENT_CARD_FAILED,
  INVALIDATE_CONTENT_CARD
} from "constants/actionTypes";

import _ from 'lodash';

const initialState = {
  items: [],
  loading: false,
  invalidated: true,
  pagination: {
    currentPage: 0,
    totalPages: 0,
  }
};

export function contentCardsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTENT_CARDS_REQUEST: {
      const { page } = action.payload;

      let cards = [...state.items];
      if(page === 0) {
        cards = [];
      }

      return {
        ...state,
        loading: true,
        items: cards
      }
    }

    case FETCHING_CONTENT_CARDS_SUCCEEDED: {
      const { records, ...pagination } = action.payload;

      let cards = [...state.items, ...records];
      cards = _.uniqBy(cards, 'id');

      return {
        ...state,
        loading: false,
        items: cards,
        pagination: pagination
      }
    }

    case FETCHING_CONTENT_CARDS_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }

    case INVALIDATE_CONTENT_CARDS: {
      return initialState;
    }

    case FETCH_CONTENT_CARD_REQUEST: {
      const id = action.payload;
      return {
        ...state,
        card: {
          ...state.card,
          [id]: {
            loading: true,
            item: null
          }
        }
      }
    }

    case FETCHING_CONTENT_CARD_SUCCEEDED: {
      const contentCard = action.payload;
      return {
        ...state,
        card: {
          ...state.card,
          [contentCard.id]: {
            loading: false,
            item: contentCard
          }
        }
      }
    }

    case FETCHING_CONTENT_CARD_FAILED: {
      const { id, error } = action.payload;
      return {
        ...state,
        card: {
          ...state.card,
          [id]: {
            loading: false,
            item: null,
            error: error
          }
        }
      }
    }

    case INVALIDATE_CONTENT_CARD: {
      return state;
    }

    default:
      return state;
  }
}